import * as React from 'react'

import Rating from 'main/components/school/Rating'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'
import { SchoolPage_school_aggregateRatings } from '../gql'
import { i18nKeyPrefix } from '../i18n'
import { Container, RatingContainer, RatingLabel } from './Ratings.styles'

const PRE = `${i18nKeyPrefix}-RATINGS`

interface IProps {
  aggregateRatings: SchoolPage_school_aggregateRatings
}

export default function Ratings(props: IProps) {
  const { aggregateRatings } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <Container>
      {renderRating(aggregateRatings.overall, t(`${PRE}-OVERALL`))}
      {renderRating(aggregateRatings.atmosphere, t(`${PRE}-ATMOSPHERE`))}
      {renderRating(aggregateRatings.physicalSpace, t(`${PRE}-PHYSICAL-SPACE`))}
      {renderRating(aggregateRatings.learningEnvironment, t(`${PRE}-LEARNING-ENVIRONMENT`))}
      {renderRating(aggregateRatings.outdoorTime, t(`${PRE}-OUTDOOR-TIME`))}
      {renderRating(aggregateRatings.childCommunication, t(`${PRE}-CHILD-COMMUNICATION`))}
      {renderRating(aggregateRatings.programCommunication, t(`${PRE}-PROGRAM-COMMUNICATION`))}
      {renderRating(aggregateRatings.providerInteraction, t(`${PRE}-PROVIDER-INTERACTION`))}
    </Container>
  )
}

function renderRating(value: number | null, label: string) {
  return (
    <RatingContainer>
      <Rating value={value || 0} withLabel />
      <RatingLabel>{label}</RatingLabel>
    </RatingContainer>
  )
}
